import {
	Flex,
	Icon,
	Spacer,
	Text,
	VStack,
	Box,
	useDisclosure,
	HStack,
	IconButton,
	Button,
} from '@chakra-ui/react'
import React, { useState, useRef } from 'react'
import { BsReply } from 'react-icons/bs'
import CustomMenu from '../../../components/menu'
import {
	dataLayerTagManager,
	GA_CATEGORY_TIMELINE,
	sectionDetailedTrack,
} from '../../../containers/repository/repo.utils'
import { parseJSONString } from '../../../utils/common.util'
import { getUTCtoIST, formatHHMM } from '../../../utils/date.utils'
import TimelineRmBotScore from './bot-score'
import { convertPound, convertUnicode } from '../../../utils/linkInText.utils'

import {
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	MenuItemOption,
	MenuGroup,
	MenuOptionGroup,
	MenuDivider,
} from '@chakra-ui/react'
import SVGIcon from '../../../assets/svgIcons'

const Message = ({ timeline, asset_id, timelineReplyData, timelineScroll }) => {
	const { isOpen, onOpen, onClose } = useDisclosure()
	const {
		isOpen: menuIsOpen,
		onOpen: menuOnOpen,
		onClose: menuOnClose,
	} = useDisclosure()

	const {
		operating_asset_first_name,
		data_entity_inline,
		datetime_log,
		log_asset_id,
		timeline_transaction_id,
		timeline_stream_type_name,
	} = timeline
	const payload = JSON.parse(data_entity_inline)
	let content = payload?.content
	let is_reply = payload?.is_reply
	let replying_to = !!is_reply && is_reply === 1 ? payload?.replying_to : {}
	if (content?.content) {
		content = content.content
	}

	const rmBotScores = parseJSONString(payload?.rm_bot_scores) || []

	const htmlDecode = content => {
		var rawMarkup = escape(content).replace(/%0A/g, '<br/>')
		return { __html: unescape(rawMarkup) }
	}
	let iconColor = log_asset_id === asset_id ? 'white' : '#009B76'
	const [isHover, setIsHover] = useState(false)
	const showMenu = useRef(false)
	let bg = log_asset_id === asset_id ? '#009B76' : 'white'

	const getCustomMenu = () => {
		return (
			<Menu isOpen={menuIsOpen}>
				<MenuButton
					as={IconButton}
					icon={
						<SVGIcon
							iconName='UpArrowSvg'
							svgProps={{ width: '18', height: '18', viewBox: '0 0 18 18' }}
							pathProps={{ fill: iconColor }}
						/>
					}
					bg={log_asset_id === asset_id ? '#009B76' : 'white'}
					_focus={{
						bg: { bg },
					}}
					_hover={{
						bg: { bg },
					}}
					_active={{
						bg: { bg },
					}}
					border='none'
					aria-label='Sort'
					size='xs'
					ml='auto'
					top='0px'
					right='0px'
					pt='8px'
					variant='outline'
					onClick={() => {
						showMenu.current = !showMenu.current
						showMenu.current ? menuOnOpen() : menuOnClose()
					}}
				/>
				<MenuList
					overflowY='auto'
					maxHeight='50vh'
					boxShadow='0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.1);'
					borderRadius='18px'
				>
					<MenuItem
						size='sm'
						py={1}
						color='#009B76'
						icon={<Icon as={BsReply} w={5} h={5} color='#009B76' />}
						onClick={e => {
							sectionDetailedTrack({
								category: GA_CATEGORY_TIMELINE,
								action: 'Message',
								label: 'Reply',
							})
							dataLayerTagManager('button_click', {
								viewName: 'File Timeline',
								buttonName: 'Reply',
							})
							timelineReplyData({ ...timeline, title: content })
						}}
					>
						Reply
					</MenuItem>
				</MenuList>
			</Menu>

			// <CustomMenu
			// 	icon={iconn}
			// 	bg={log_asset_id === asset_id ? '#009B76' : 'white'}
			// 	color='#009B76'
			// 	borderRadius='md'
			// 	boxShadow={0}
			// 	aria-label='More'
			// 	size='xs'
			// 	ml='auto'
			// 	top='0px'
			// 	right='0px'
			// 	_focus={{
			// 		bg: { focusBg },
			// 	}}
			// 	_hover={{
			// 		bg: { focusBg },
			// 	}}
			// 	optionList={[
			// 		{
			// 			label: `Reply`,
			// 			isMenu: true,
			// 			icon: <Icon as={BsReply} w={5} h={5} color='#009B76' />,
			// 			onClick: e => {
			// 				sectionDetailedTrack({
			// 					category: GA_CATEGORY_TIMELINE,
			// 					action: 'Message',
			// 					label: 'Reply',
			// 				})
			// 				dataLayerTagManager('button_click', {
			// 					viewName: 'File Timeline',
			// 					buttonName: 'Reply',
			// 				})
			// 				timelineReplyData({ ...timeline, title: content })
			// 			},
			// 			optionListProps: {
			// 				color: '#009B76',
			// 			},
			// 		},
			// 	]}
			// 	selected={{}}
			// />
		)
	}

	const showUpArrow = () => {
		setIsHover(true)
	}

	const hideUpArrow = () => {
		showMenu.current = false
		menuOnClose()
		setIsHover(false)
	}
	return (
		<>
			{rmBotScores?.length > 0 ? (
				<TimelineRmBotScore
					score={rmBotScores}
					isOpen={isOpen}
					onClose={onClose}
					content={content}
				/>
			) : null}

			<Flex
				className={`timeline-message-component`}
				id={`reply_item${timeline_transaction_id}`}
				justifyContent='flex-start'
				alignItems='flex-start'
				my={4}
				flexDirection={log_asset_id === asset_id ? 'row-reverse' : 'row'}
			>
				<VStack
					className={`message-component-custom-menu-container`}
					justifyContent='space-around'
					alignItems='center'
					bg={log_asset_id === asset_id ? '#009B76' : 'white'}
					color={log_asset_id === asset_id ? 'white' : 'black'}
					borderRadius={
						log_asset_id === asset_id
							? '15px 15px 0px 15px'
							: '0px 12px 12px 12px'
					}
					minh='170px'
					maxh='250px'
					wordBreak='break-word'
					minW='300px'
					maxW='500px'
					mx={2}
					px={4}
					py={2}
					mr='2rem'
					position='relative'
					cursor={'pointer'}
					onMouseEnter={() => showUpArrow()}
					onMouseLeave={() => hideUpArrow()}
				>
					{log_asset_id !== asset_id && (
						<HStack justifyContent='space-between' w='100%'>
							<Text color='brand.700' fontSize='0.875rem' fontWeight='500'>
								{operating_asset_first_name}
							</Text>
							<Box visibility={isHover ? 'visible' : 'hidden'}>
								{getCustomMenu()}
							</Box>
						</HStack>
					)}
					<Spacer />
					{is_reply === 1 && (
						<HStack w='100%' justifyContent={'space-between'}>
							<Box
								className='reply-qoute'
								whiteSpace={'pre-line'}
								onClick={() => {
									sectionDetailedTrack({
										category: GA_CATEGORY_TIMELINE,
										action: 'Message',
										label: 'Timeline Scroll',
									})
									timelineScroll(
										`reply_item${replying_to.timeline_transaction_id}`
									)
								}}
								ml='0px'
							>
								<Text>
									<Text fontWeight='500' fontSize='sm' color='blackAlpha.700'>
										{replying_to.log_asset_first_name}
									</Text>
								</Text>
								<Text
									whiteSpace='pre-line'
									fontSize='sm'
									fontWeight='400'
									dangerouslySetInnerHTML={{
										__html: convertPound(
											convertUnicode(unescape(replying_to.content))
										),
									}}
								/>
							</Box>
							{log_asset_id === asset_id && is_reply === 1 && (
								<Box
									visibility={isHover ? 'visible' : 'hidden'}
									alignSelf='flex-start'
								>
									{getCustomMenu()}
								</Box>
							)}
						</HStack>
					)}
					<HStack justifyContent='space-between' w='100%'>
						<Text
							textAlign='left'
							alignSelf='flex-start'
							whiteSpace='pre-line'
							fontSize='14px'
							fontWeight='500'
							// color={rmBotScores?.length > 0 ? 'brand.900' : 'initial'}
							color={log_asset_id === asset_id ? 'white' : 'black'}
							textDecoration={rmBotScores?.length > 0 ? 'underline' : ''}
							cursor={rmBotScores?.length > 0 ? 'pointer' : ''}
							onClick={() => {
								if (rmBotScores?.length > 0) onOpen()
							}}
							dangerouslySetInnerHTML={{
								__html: convertPound(convertUnicode(unescape(content))),
							}}
						/>
						{log_asset_id === asset_id && is_reply !== 1 ? (
							<Box visibility={isHover ? 'visible' : 'hidden'}>
								{getCustomMenu()}
							</Box>
						) : null}
					</HStack>
					<Text fontSize='10px' mb={0} alignSelf='flex-end'>
						{formatHHMM(getUTCtoIST(datetime_log))}
					</Text>
				</VStack>
			</Flex>
		</>
	)
}

export default Message
